import React, { useEffect, useState } from "react";
import "./App.css";
import { Box } from "@mui/material";
import Login from "./Components/Login/component";
import Cookies from "universal-cookie";
import TopNav from "./Components/TopNav/component";
import Entries from "./Components/Entries/component";
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Dogs from "./Components/Dogs/component";
import EntryOverview from "./Components/Entries/Overview/component";
import ShowManagement from "./Components/ShowManagement/component";
import ShowEntryOverviews from "./Components/ShowManagement/EntryOverviews/component";
import AgilityClubs from "./Components/AgilityClubs/component";
import ClubMemberships from "./Components/ClubMemberships/component";
import PrivacyPolicy from "./Components/PrivacyPolicy/component";
import Handlers from "./Components/Handlers/component";
import PricingPage from "./Components/Pricing/component";
import SharedVenueHirePage from "./Components/AgilityClubs/SharedVenueHirePage";
import SharedSessionBookingPage from "./Components/AgilityClubs/SharedSessionBookingPage";
import CreateClubDialog from "./Components/AgilityClubs/CreateClubDialog";
import Notify from "./Components/Notify/component";
import { featureFlags } from "./utils/featureFlags";
import { hasCreateClubIntent } from "./utils/createClub";

function MainAppRoutes({
  setLoggedIn,
}: {
  setLoggedIn: (loggedIn: boolean) => void;
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const [createClubOpen, setCreateClubOpen] = useState(
    () => hasCreateClubIntent(location.search),
  );
  const [createClubError, setCreateClubError] = useState("");
  const [notifyOpen, setNotifyOpen] = useState(false);

  useEffect(() => {
    setCreateClubOpen(hasCreateClubIntent(location.search));
  }, [location.search]);

  const handleCreateClubClose = () => {
    setCreateClubOpen(false);
    if (hasCreateClubIntent(location.search)) {
      navigate("/", { replace: true });
    }
  };

  const handleCreateClubSuccess = () => {
    setCreateClubOpen(false);
    if (featureFlags.clubAdministration) {
      navigate("/agility-clubs", { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  };

  return (
    <Box minHeight="100vh" bgcolor={"#f5f4f0"}>
      <TopNav setLoggedIn={setLoggedIn} />
      {featureFlags.clubAdministration && (
        <CreateClubDialog
          open={createClubOpen}
          onClose={handleCreateClubClose}
          onSuccess={handleCreateClubSuccess}
          onError={(message) => {
            setCreateClubError(message);
            setNotifyOpen(true);
          }}
        />
      )}
      <Notify
        open={notifyOpen}
        setOpen={setNotifyOpen}
        message={createClubError}
        severity="error"
      />
      <Routes>
        <Route path="/" element={<Entries />} />
        <Route path="/dogs" element={<Dogs />} />
        <Route path="/handlers" element={<Handlers />} />
        <Route path="/shows/:id" element={<EntryOverview />} />
        <Route path="/show-management" element={<ShowManagement />} />
        <Route
          path="/show-management/:showId/entries"
          element={<ShowEntryOverviews />}
        />
        {featureFlags.clubAdministration && (
          <Route path="/agility-clubs" element={<AgilityClubs />} />
        )}
        {featureFlags.clubMemberships && (
          <Route path="/club-memberships" element={<ClubMemberships />} />
        )}
      </Routes>
    </Box>
  );
}

function App() {
  const [loggedIn, setLoggedIn] = React.useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authenticateResults = urlParams.get("authenticate-results");
    console.log(authenticateResults);

    if (authenticateResults === "true") {
      console.log("Authentication results present");

      const cookies = new Cookies();
      const token = cookies.get("token");
      if (token) {
        window.location.href = `https://results.easyagility.co.uk?token=${token}`;
      }
    }

    const authenticateEntries = urlParams.get("authenticate-entries");
    console.log(authenticateEntries);

    if (authenticateEntries === "true") {
      console.log("Authentication entries results present");

      const cookies = new Cookies();
      const token = cookies.get("token");
      if (token) {
        window.location.href = `https://entries.easyagility.co.uk?token=${token}`;
      }
    }
  }, []);

  useEffect(() => {
    const cookies = new Cookies();
    const token = cookies.get("token");
    if (token) {
      setLoggedIn(true);
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route
          path="/venue-hire/:shareToken"
          element={
            <SharedVenueHirePage
              loggedIn={loggedIn}
              setLoggedIn={setLoggedIn}
            />
          }
        />
        <Route
          path="/sessions/:shareToken"
          element={
            <SharedSessionBookingPage
              loggedIn={loggedIn}
              setLoggedIn={setLoggedIn}
            />
          }
        />
        <Route
          path="*"
          element={
            loggedIn ? (
              <MainAppRoutes setLoggedIn={setLoggedIn} />
            ) : (
              <Login setLoggedIn={setLoggedIn} />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
